<template>
  <div>
    <h3>Beta development</h3>
    Simulate two satellites flying in formation.
    One is the leader and the other is the follower, which will fly
    around a formation center.
    <v-img
    contain
    :src="require('../../../assets/images/formation-flying.png')"
    aspect-ratio="3"
    />
    <br />
    <h3>Control</h3>
      Once the follower reach a control box (which is about 75% smaller of formation flying box), a command is computed and executed by the follower to reach the formation center.
      The follower spacecraft never exceed the formation flying box (figure show in TNW local orbital frame).
      <v-img
      contain
      :src="require('../../../assets/images/control-box.png')"
      aspect-ratio="3"
    />
    <br />
    <h3>Local orbital frame</h3>
      Here the TNW local orbital frame is recall with:
      <ul>
        <li>X axis: unit vector in the direction of satellite's velocity vector</li>
        <li>Z axis: unit vector in the same direction as the orbit's angular momentum vector, that is, perpendicular to the orbit plane</li>
        <li>Y axis: unit vector chosen so that the (X,Y,Z) trihedral is direct</li>
      </ul>
      <v-img
      contain
      :src="require('../../../assets/images/tooltip-attitude.png')"
      aspect-ratio="3"
    />
    <br />
    <h3>Hypotheses</h3>
      <p>The underlying assumptions for this beta are the following:</p>
        <ul>
          <li>Both satellites are identical</li>
          <li>The same perturbations is applied on leader and follower spacecraft</li>
          <li>The formation center is at the same altitude of the leader</li>
          <li>The spacecraft have a propulsion system sufficient to easily control the spacecraft trajectory</li>
          <li>Spacecraft is on frozen LEO</li>
        </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipFormationFlying'
}
</script>
